module.exports = __webpack_public_path__ + "img/deathwish.27864133.jpg";